/*
 * Werkzeugleiste aus gleich grossen Icon-Knöpfen; der Text steht nur im
 * Tooltip (Patrick, 22.10.2026: frei laufende Knöpfe in unterschiedlicher
 * Länge sehen unruhig aus). Für Datenpunkte-Ansicht und Gerätekopf.
 */
import type { ComponentChildren } from 'preact';
import './ToolButton.css';

interface Props {
  /** Tooltip und Name für Screenreader. */
  label: string;
  children: ComponentChildren;
  onClick?: () => void;
  href?: string;
  /** Umschalter: gedrückt dargestellt und aria-pressed gesetzt. */
  active?: boolean;
  tone?: 'default' | 'danger' | 'accent';
  disabled?: boolean;
}

export function ToolButton({ label, children, onClick, href, active, tone = 'default', disabled }: Props) {
  const cls = `hv-toolbtn hv-toolbtn--${tone}${active ? ' hv-toolbtn--active' : ''}`;
  if (href) {
    return <a class={cls} href={href} title={label} aria-label={label}>{children}</a>;
  }
  return (
    <button type="button" class={cls} title={label} aria-label={label} onClick={onClick} disabled={disabled}
            aria-pressed={active === undefined ? undefined : active}>
      {children}
    </button>
  );
}

/** Gruppe von Knöpfen; mehrere Gruppen trennt ein feiner Strich. */
export function ToolGroup({ children, label }: { children: ComponentChildren; label?: string }) {
  return <div class="hv-toolgroup" role="group" aria-label={label}>{children}</div>;
}
